import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { formatNumber } from "../../Utils/formatters";
import "./ProfileStatus.css";

function ProfileStatus({ data }) {
  const defaultData = [
    { name: "Active", value: 0, percentage: 0, color: "#52c41a" },
    { name: "Inactive", value: 0, percentage: 0, color: "#faad14" },
    { name: "Under Verification", value: 0, percentage: 0, color: "#722ed1" },
    { name: "Rejected", value: 0, percentage: 0, color: "#f5222d" },
  ];

  const chartData = data && data.length > 0 ? data : defaultData;
  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="profile-status-card">
      <h3 className="chart-title">Profile Status Overview</h3>

      <div className="profile-status-content">
        <div className="profile-chart-wrapper">
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={80}
                paddingAngle={3}
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value) => formatNumber(value)}
                contentStyle={{
                  borderRadius: "10px",
                  border: "1px solid #f0f0f0",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                }}
              />
            </PieChart>
          </ResponsiveContainer>

          <div className="chart-center-content">
            <p className="center-label">Total Profiles</p>
            <h2 className="center-value">{formatNumber(total)}</h2>
          </div>
        </div>

        <div className="profile-status-legend">
          {chartData.map((item, index) => (
            <div key={index} className="legend-item">
              <div className="legend-info">
                <span
                  className="legend-dot"
                  style={{ background: item.color }}
                ></span>
                <span className="legend-name">{item.name}</span>
              </div>
              <div className="legend-values">
                <strong>{formatNumber(item.value)}</strong>
                <span className="legend-percent">
                  ({item.percentage ?? 0}%)
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProfileStatus;